(function($, BCCShopify) {

    var ProductBundler = function() {

        /**
         * Create a random string identifier
         *
         * @returns {string}
         */
        var generateId = function () {
            return Math.floor((Math.random() * 999999) + 1);
        }

        /**
         * Add a collection of variants to cart and tie them together with a bundle id
         *
         * @param variants
         * @param fn
         */
        this.addProductBundle = function (variants, fn) {
            var currentCount = 0;
            var itemCount = variants.length;
            var lineItems = [];
            var uid = generateId();
            $.each(variants, function (i, variant) {
                data = {
                    id: variant.id,
                    properties: {
                        'id': uid
                    }
                }
                if(variant.properties) {
                    $.extend(data.properties, variant.properties);
                }
                var params = {
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    dataType: 'json',
                    success: function(line_item) {
                        if ((typeof fn) === 'function') {
                            currentCount++;
                            lineItems.push(line_item);
                            if (currentCount >= itemCount){
                                fn(lineItems);
                            }
                        }
                        else {
                            BCCShopify.onItemAdded(line_item);
                        }
                    },
                    error: function(XMLHttpRequest, textStatus) {
                        BCCShopify.onError(XMLHttpRequest, textStatus);
                    }
                };
                BCCShopify.queueAjaxRequest(params);
            });
        }

        /**
         * Remove all variants with the passed-in bundle id
         *
         * @param id
         * @param fn
         */
        this.removeProductBundle = function (id, fn) {

            BCCShopify.getCart(function (cart) {
                var items = [];
                $.each(cart.items, function (i, item) {
                    if (item.properties && item.properties.id === id) {
                        item.line_index = i + 1;
                        items.push(item);
                    }
                });

                var currentCount = 0;
                var itemCount = items.length;
                var removeIndex;
                $.each(items, function (i, item) {

                    if (!removeIndex) {
                        removeIndex = item.line_index;
                    }

                    var params = {
                        type: 'POST',
                        url: '/cart/change.js',
                        data: { quantity: 0, line: removeIndex },
                        dataType: 'json',
                        success: function(cart) {
                            if ((typeof fn) === 'function') {
                                currentCount++;
                                if (currentCount >= itemCount){
                                    fn(cart);
                                }
                            }
                            else {
                                BCCShopify.onCartUpdate(cart);
                            }
                        },
                        error: function(XMLHttpRequest, textStatus) {
                            BCCShopify.onError(XMLHttpRequest, textStatus);
                        }
                    };
                    BCCShopify.queueAjaxRequest(params);
                });
            });
        }
    }

    if($ && BCCShopify) {
        BCCShopify = $.extend(BCCShopify, new ProductBundler());
    } else {
        console.error('[ProductBundler] Missing dependencies.');
    }
})(jQuery, BCCShopify);